import {game_1008} from "./game_1008";
import {game_1001} from "./game_1001";
import {game_1002} from "./game_1002";
import {game_1004} from "./game_1004";
import {game_1003} from "./game_1003";
import {game_1005} from "./game_1005";
import {game_1006} from "./game_1006";
import {game_1007} from "./game_1007";
import {game_1000} from "./game_1000";


function fish_utils()
{

}


fish_utils.read_odd = function(game_id,id)
{
  console.log("game_id::"+game_id+"id:::"+id);
  let fish_id = parseInt(id);
  if(game_id === 1000)
  {
    return game_1000.read_odd(fish_id);
  }
  else if(game_id === 1001)
  {
    return game_1001.read_odd(fish_id);
  }
  else if(game_id === 1002)
  {
    return game_1002.read_odd(fish_id);
  }
  else if(game_id === 1003)
  {
    return game_1003.read_odd(fish_id);
  }
  else if(game_id === 1004)
  {
      return game_1004.read_odd(fish_id);
  }
  else if(game_id === 1005)
  {
    return game_1005.read_odd(fish_id);
  }
  else if(game_id === 1006)
  {
    return game_1006.read_odd(fish_id);
  }
  else if(game_id === 1007)
  {
    return game_1007.read_odd(fish_id);
  }
  else if(game_id === 1008)
  {
    return game_1008.read_odd(fish_id);
  }
}

export {
  fish_utils
};



// WEBPACK FOOTER //
// ./src/components/fish/fish_utils.js